import { StrictMode } from 'react';

import * as ReactDOM from 'react-dom/client';

import { initGA } from '@codes/analytics';

import App from './app/app';

initGA();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
    <StrictMode>
        <App />
    </StrictMode>
);
